export function toFixed(n: number, f: number) {
    return Number(n.toFixed(f));
}
